var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemUiconsCircleMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 21.1431C17.0497 21.1431 21.1431 17.0497 21.1431 12.0003C21.1431 6.95082 17.0497 2.85742 12.0003 2.85742C6.95082 2.85742 2.85742 6.95082 2.85742 12.0003C2.85742 17.0497 6.95082 21.1431 12.0003 21.1431Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0014 13.5437C12.673 13.5437 13.3446 12.8721 13.3446 12.2006C13.3446 11.529 12.673 10.8574 12.0014 10.8574C11.3299 10.8574 10.6596 11.529 10.6596 12.2006C10.6596 12.8721 11.3299 13.5437 12.0014 13.5437ZM6.6289 13.5437C7.30047 13.5437 7.97203 12.8721 7.97203 12.2006C7.97203 11.529 7.30047 10.8574 6.6289 10.8574C5.95733 10.8574 5.28711 11.529 5.28711 12.2006C5.28711 12.8721 5.95733 13.5437 6.6289 13.5437ZM17.374 13.5437C18.0455 13.5437 18.7171 12.8721 18.7171 12.2006C18.7171 11.529 18.0455 10.8574 17.374 10.8574C16.7024 10.8574 16.0322 11.529 16.0322 12.2006C16.0322 12.8721 16.7024 13.5437 17.374 13.5437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsCircleMenu);
export default __webpack_public_path__ + "static/media/system-uicons_circle-menu.831cc7af2ef4392f167cd968bd2fd524.svg";
export { ForwardRef as ReactComponent };